import { ADDTOCART, DECREMENT } from "./actionsType";

const initialState = {
    productStore: [
        { name: "Asus Vivobook X515MA", price: 35500, availableStock: 20 },
        { name: "Dell E1916HV 18.5 Inch", price: 9300, availableStock: 35 },
        { name: "Canon Eos 4000D 18MP", price: 36500, availableStock: 72 },
    ], cart: []
}

const reducer = (state = initialState, action) => {
    const newState = { productStore: [...state.productStore], cart: [...state.cart] }

    if (action.type === ADDTOCART) {
        const indexOfCart = newState.cart.findIndex(({ name }) => name === action.payload.name);
        const indexOfProductStore = newState.productStore.findIndex(({ name }) => name === action.payload.name);
        newState.productStore[indexOfProductStore] = { ...newState.productStore[indexOfProductStore], availableStock: newState.productStore[indexOfProductStore].availableStock - 1 }
        if (indexOfCart < 0) {
            newState.cart.push({ name: action.payload.name, price: action.payload.price, quantity: 1 });
        } else {
            newState.cart[indexOfCart] = { ...newState.cart[indexOfCart], quantity: newState.cart[indexOfCart].quantity + 1 }
        }
        return newState;
    } else if (action.type === DECREMENT) {
        const indexOfCart = newState.cart.findIndex(({ name }) => name === action.payload.name);
        const indexOfProductStore = newState.productStore.findIndex(({ name }) => name === action.payload.name);
        if (newState.cart[indexOfCart].quantity > 1) {
            newState.cart[indexOfCart] = { ...newState.cart[indexOfCart], quantity: newState.cart[indexOfCart].quantity - 1 }
        } else {
            newState.cart = newState.cart.filter(el => el.name !== action.payload.name);
        }
        newState.productStore[indexOfProductStore] = { ...newState.productStore[indexOfProductStore], availableStock: newState.productStore[indexOfProductStore].availableStock + 1 }
        return newState;
    } else {
        return state;
    }
}

export default reducer;